<template>
  <div class="modal is-active">
    <div @click="close()" class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Move to Library</p>
        <button @click="$emit('close')" class="delete"></button>
      </header>
      <section class="modal-card-body">
        <p class="control" v-if="libraries.length > 0">
          <span class="select">
            <div class="select">
              <select v-model='libraryID'>
                <option v-for="lib in libraries" :value="lib.id">{{ lib.title }}</option>
              </select>
            </div>
          </span>
        </p>
        <p v-else>
          No libraries accessible.
        </p>

      </section>
      <footer class="modal-card-foot">
        <a class="button is-info" :disabled="libraries.length === 0" @click='addLibrary()'>Add</a>
        <a @click="$emit('close')" class="button">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>

import store from '../store.js'

export default {
  name: 'MovetoLibraryModal',
  mounted () {
    store.dispatch('fetchLibraries')
  },
  data () {
    return {
      libraryID: null,
    }
  },
  computed: {
    libraries () {
      return store.state.libraries
    },
  },
  props: ['videoID'],
  methods: {
    async addLibrary () {
      const libraryID = this.libraryID
      const videoID = this.videoID
      // TODO: add loading states and error state in the store
      await store.dispatch('updateVideoLibrary', { videoID, libraryID })
      this.close()
    },
    close () {
      this.$emit('close')
    },
    handleESC (e) {
      const ESC = 27
      if (e.keyCode === ESC) {
        this.close()
      }
    },
  },
  created () {
    document.addEventListener('keydown', this.handleESC)
  },
  beforeDestory () {
    document.removeEventListener('keydown', this.handleESC)
  },
}

</script>

<style>

input.file-upload {
  margin-bottom: 1.5rem;
}


</style>



// WEBPACK FOOTER //
// MovetoLibraryModal.vue?db2892ca